var scope_0 = require('/Users/Yomgui/code/blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1b69bef9545b328b6df393ae3c99cfa2.js').default;
var scope_1 = require('/Users/Yomgui/code/blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2cae7efb8f6f286f1dfcf235966948af.js').default;
var scope_2 = require('/Users/Yomgui/code/blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c6bf4ed7a0fee37f307a5732fbbb189e.js').default;
var scope_3 = require('/Users/Yomgui/code/blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c78850c53fc2c8c1460d8c18ccb04b9f.js').default;
var scope_4 = require('/Users/Yomgui/code/blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    